<div id="st-profile-status-popup-profile-status-overlay" class="profile-status-overlay" *ngIf="visible" role="dialog" aria-modal="true">
  <div id="st-profile-status-popup-profile-status-modal" class="profile-status-modal" role="document">
    <ng-container *ngTemplateOutlet="type === 'complete_profile' ? completeProfileTemplate : (type === 'verification_rejected' ? verificationRejectedTemplate : verificationPendingTemplate)"></ng-container>
  </div>
</div>

<ng-template #completeProfileTemplate>
  <div id="st-profile-status-popup-popup-content" class="popup-content popup-complete-profile">
    <div id="st-profile-status-popup-popup-illustration" class="popup-illustration">
      <img src="assets/profile-completion.png" alt="Complete your profile" class="profile-completion-img" />
    </div>
    <div id="st-profile-status-popup-progress-section" class="progress-section">
      <div id="st-profile-status-popup-progress-bar" class="progress-bar">
        <div id="st-profile-status-popup-progress-fill" class="progress-fill" [style.width.%]="profileProgress"></div>
        <div id="st-profile-status-popup-progress-thumb" class="progress-thumb" [style.left.%]="profileProgress"></div>
      </div>
      <span class="progress-percent">{{ profileProgress }}%</span>
    </div>
    <h3 class="popup-title">{{ 'complete_your_profile' | translate }}</h3>
    <p class="popup-description">{{ 'complete_profile_message_1' | translate }}</p>
    <p class="popup-description popup-description-sub">{{ 'complete_profile_message_2' | translate }}</p>
    <button type="button" class="popup-btn popup-btn-primary" (click)="onEditProfileClick()" (keydown.enter)="onEditProfileClick()" (keydown.space)="$event.preventDefault(); onEditProfileClick()" tabindex="0">
      <i class="pi pi-pencil"></i>
      <span>{{ 'edit_profile' | translate }}</span>
    </button>
  </div>
</ng-template>

<ng-template #verificationPendingTemplate>
  <div id="st-profile-status-popup-popup-content-1" class="popup-content popup-verification-pending">
    <div id="st-profile-status-popup-popup-illustration-2" class="popup-illustration">
      <img src="assets/verification_pending.png" alt="Verification Pending" class="verification-pending-img" />
    </div>
    <h3 class="popup-title">{{ 'verification_pending' | translate }}</h3>
    <p class="popup-description">{{ 'verification_pending_message' | translate }}</p>
    <button type="button" class="popup-btn popup-btn-primary" (click)="closePopup()" (keydown.enter)="closePopup()" (keydown.space)="$event.preventDefault(); closePopup()" tabindex="0">
      {{ 'close' | translate }}
    </button>
  </div>
</ng-template>

<ng-template #verificationRejectedTemplate>
  <div id="st-profile-status-popup-popup-content-3" class="popup-content popup-verification-pending">
    <div id="st-profile-status-popup-popup-illustration-4" class="popup-illustration">
      <img src="assets/verification_pending.png" alt="Verification Rejected" class="verification-pending-img" />
    </div>
    <h3 class="popup-title">{{ 'verification_rejected' | translate }}</h3>
    <p class="popup-description">{{ 'sorry_your_application_rejected' | translate }}</p>
    <button type="button" class="popup-btn popup-btn-primary" (click)="onEditProfileClick()" (keydown.enter)="onEditProfileClick()" (keydown.space)="$event.preventDefault(); onEditProfileClick()" tabindex="0">
      <i class="pi pi-pencil"></i>
      <span>{{ 'edit_profile' | translate }}</span>
    </button>
  </div>
</ng-template>
